<template>
  <el-carousel :interval="3000" height="460px" indicator-position="none" :autoplay="true">
    <el-carousel-item v-for="(item, idx) in imageList" :key="idx" class="carousel_item">
      <div class="content" @click="jumpUrl">
        <img :src="item" />

        <div class="text_wrapper">
          <div class="title">
            新金融、新智造、新动能
          </div>
          <div class="text">
            专家学者共聚2024“影响力·时代”峰会，共话新金融新智造新动能
          </div>
        </div>

      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import msgCarouselImage0 from "@/assets/img/jinju-2024/msg_carousel_0.png"
// import msgCarouselImage1 from "@/assets/img/jinju-2024/msg_carousel_1.jpg"
// import msgCarouselImage2 from "@/assets/img/jinju-2024/msg_carousel_2.jpg"
// import msgCarouselImage3 from "@/assets/img/jinju-2024/msg_carousel_3.jpg"
// import msgCarouselImage4 from "@/assets/img/jinju-2024/msg_carousel_4.jpg"

export default {
  data() {
    return {
      imageList: [msgCarouselImage0]
    }
  },
  methods: {
    jumpUrl() {
      window.open("https://www.time-weekly.com/post/312401", "_blank");
    }
  }

}
</script>

<style lang="scss" scoped>
.carousel_item {
  height: 100%;
}

.content {
  cursor: pointer;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  position: relative;

  img {
    width: 100%;
    object-fit: cover;
  }


  .text_wrapper {
    position: absolute;
    padding-top: 15px;
    padding-left: 20px;
    padding-bottom: 15px;
    bottom: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.5), transparent);

    .title {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 24px;
    }

    .text {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #D9D9D9;
      line-height: 22px;
    }
  }

}
</style>
